module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/reviews-powered-by-google-ebc08c82bc55397bc1d826d639265af4.svg";